<div *ngIf="obj" id="details-container">

  <mat-tab-group class="custom-tab-group" #tabGroup [(selectedIndex)]="selectedTabIndex">
    <mat-tab id="firstTab" #detailTab [disabled]="!hasDetail()">
      <ng-template mat-tab-label>
        <div class="label-content">
        <mat-icon class="tab-icon" svgIcon="details-tab"></mat-icon>
        <span class="label-text">Details</span>
        </div>
      </ng-template>
      <ng-template matTabContent>
        @if (obj()) {
          <cr-description-tab [obj]="obj()!" [analysisResult]="analysis.result()"></cr-description-tab>
        }
      </ng-template>
    </mat-tab>

    <mat-tab #moleculeTab>
      <ng-template mat-tab-label>
        <div class="label-content">
        <mat-icon class="tab-icon" svgIcon="molecule-tab"></mat-icon>
        <span class="label-text">Molecule</span>
        </div>
      </ng-template>
      <ng-template matTabContent>
        <cr-molecule-tab [obj]="obj()!"></cr-molecule-tab>
      </ng-template>
    </mat-tab>

    <mat-tab #resultsTab [disabled]="!hasResult()">
      <ng-template mat-tab-label>
        <div class="label-content">
        <mat-icon class="tab-icon" svgIcon="results-tab"></mat-icon>
        <span class="label-text">Results</span>
        </div>
      </ng-template>
      <ng-template matTabContent>
        <cr-result-tab></cr-result-tab>
      </ng-template>
    </mat-tab>

    <mat-tab #expressionTab>
      <ng-template mat-tab-label>
        <div class="label-content">
        <mat-icon class="tab-icon" svgIcon="expression-tab"></mat-icon>
        <span class="label-text">Expression</span>
        </div>
      </ng-template>
      <ng-template matTabContent>
        <cr-expression-tab [obj]="obj()!"></cr-expression-tab>
      </ng-template>
    </mat-tab>

    <mat-tab #infoTab>
      <ng-template mat-tab-label>
        <div class="label-content">
        <mat-icon class="tab-icon" svgIcon="info-tab"></mat-icon>
        <span class="label-text">Info</span>
        </div>
      </ng-template>
      <ng-template matTabContent>
        <cr-info-tab></cr-info-tab>
      </ng-template>
    </mat-tab>

    <mat-tab #downloadTab>
      <ng-template mat-tab-label>
        <div class="label-content">
        <mat-icon class="tab-icon" svgIcon="download-tab"></mat-icon>
        <span class="label-text">Download</span>
        </div>
      </ng-template>
      <ng-template matTabContent>
       Download Content
      </ng-template>
    </mat-tab>

  </mat-tab-group>
</div>
